import NotePage from 'components/notePage/notePage.component';
import { Form } from 'formik';
import colors from 'style-utils/colors';
import media from 'style-utils/media-queries';
import { Flex } from 'style/flexbox.style';
import styled from 'styled-components';

interface ContainerMessagePropsOtp {
  isPresentMessage: boolean | undefined;
  isError?: boolean;
}

//done
export const ContainerModalOtp = styled.div`
  display: flex;
  justify-content: center;

  & > img {
    position: absolute;
    z-index: 100;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;

//done
export const CentralBoxOtp = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  padding: 16px 16px 24px 16px;

  ${media.desktop`
    padding: 24px 16px;
  `}
`;

//done
export const BottomBoxOtp = styled(Flex)`
  width: 100%;
  padding: 16px;
  box-shadow: inset 0 0.5px 0 #d9d9d9;
  border-radius: 10px 10px 0 0;

  ${media.desktop`
    box-shadow: none;
    border-radius: 0;
  `}
`;

export const FormOtp = styled(Form)`
  position: relative;
  width: 100%;
`;

export const FlexOtp = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const MessageErrorOtp = styled.span`
  display: none;
  margin-top: 4px;
  font-family: var(--primary-font-family), sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
`;

export const ContainerMessageOtpRoot = styled.div<ContainerMessagePropsOtp>`
  display: block;
  width: 100%;
  font-size: 16px;
  line-height: 1.1875;
  ${({ isPresentMessage, isError }) => {
    if (isPresentMessage) {
      return `
        & > ${MessageErrorOtp} {
          ${isError ? `color: #E32219` : `color: ${colors.verifiedState}`};
          display:block;
        }
      `;
    }
    return '';
  }}
`;

export const MessageInfoOTp = styled.p`
  width: 100%;
  margin: 10px 0 0;
  font-family: var(--primary-font-family), sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: ${colors.verifiedState};
  max-width: 320px;
`;

export const VerifySubtitle = styled.h2`
  margin: 0 0 32px;
  font-size: 14px;
  line-height: 18px;
  color: ${colors.blackTwelve};
  font-weight: 400;

  ${media.tablet`
    margin-top: 8px;
  `}
`;

export const RefreshText = styled.span`
  margin: 16px 0 8px;
  font-family: var(--primary-font-family), sans-serif;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  color: ${colors.blackTwelve};
  z-index: 1;
  ${media.desktop`
    margin-top: 32px;
  `}
`;

export const RefreshCTA = styled.span`
  margin: 0 0 0 4px;
  font-family: var(--primary-font-family), sans-serif;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-decoration: underline;
  color: ${colors.blackTwelve};
  cursor: pointer;
`;

export const RefreshBlockNote = styled.div`
  border-left: 5px solid ${colors.yellowNote};
  padding-left: 15px;
  margin: 0 0 7px;

  > p {
    font-family: var(--primary-font-family), sans-serif;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.28px;
    color: ${colors.greenUltraDark};
    text-align: left;
  }
`;

export const RefreshCooldownBox = styled.div`
  width: 100%;
  margin: 0 0 7px;
  font-family: var(--primary-font-family), sans-serif;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  color: ${colors.blackTwelve};
`;

export const RefreshBox = styled.div`
  margin: 0 auto 7px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const NotePageOtp = styled(NotePage)`
  margin-top: 16px;
  > span {
    > span {
      display: block;
    }
  }
  ${media.desktop`
    > span {
      > span {
        display: inline;
      }
    }
  `}
`;
